import React from 'react';
import { Container, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3, 2),
		height: '100vh',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center'
	}
}));

const NotFound = () => {
    const { root } = useStyles();

    return (
        <Container className={root}>
            <Typography component="h1" variant="h5" align="center">
                Došlo je do greške (404)
            </Typography>
        </Container>
    )
}

export default NotFound;
